import initRoadMap from './init-roadmap';

document.addEventListener('DOMContentLoaded', () => {
  fetch('/config.json')
    .then((response) => response.json())
    .then((config) => initRoadMap(config));
});
